var EHDI = EHDI || Object.create(null);

EHDI.game = EHDI.game || Object.create(null);

EHDI.game.AddDiscContainer = function() {
    EHDI.aka.Container.call(this);
};

EHDI.game.AddDiscContainer.prototype = Object.create(EHDI.aka.Container.prototype);

EHDI.game.AddDiscContainer.prototype.init = function () {
  this._textContainer;
  this._text1;
  this._animation;

  if (this._textContainer == null) {
    this._textContainer = new EHDI.aka.Container();

    this.addChild(this._textContainer);
  }

  if (this._text1 == null) {
    this._text1 = new EHDI.displays.TextSprite(EHDI.GAME.jsonManager.getLocale("STR_ADD_DISC_ANIMATION"));

    this._text1.anchor.x = 0.5;
    this._text1.anchor.y = 0.5;

    this._textContainer.addChild(this._text1);
  }

  if (this._animation == null) {
    this._animation = new EHDI.game.Effect();
    this._animation.init('burst_fx');
    this._animation.getDisplay().scale.x = 0.6;
    this._animation.getDisplay().scale.y = 0.6;
    // this._animation.getDisplay().x = -100;
    // this._animation.getDisplay().visible = false;
    this.addChild(this._animation.getDisplay());
  }

  this.visible = false;
}

EHDI.game.AddDiscContainer.prototype.destroy = function () {
  if (this._tl1 != null) {
    this._tl1.kill();
    this._tl1 = null;
  }

  if (this._animation != null) {
    this.removeChild(this._animation.getDisplay());
    this._animation.destroy();
    this._animation = null;
  }

  if (this._text1 != null) {
    this._textContainer.removeChild(this._text1);
    this._textContainer = null;
  }

  if (this._textContainer != null) {
    this.removeChild(this._textContainer);

    this._textContainer = null;
  }
}

EHDI.game.AddDiscContainer.prototype.spawn = function (count) {
  this.visible = true;
  this._textContainer.y = 0;
  this._textContainer.alpha = 1;

  this._text1.setText("+" + count);

  this._animation.changeAnimation(false, 'pickglow2');

  this._tl1 = TweenLite.to(this._textContainer, 1.5,{y:this._textContainer.y - 100, alpha:0, onComplete:this.animationComplete.bind(this)});
}

EHDI.game.AddDiscContainer.prototype.animationComplete = function (points) {
  this.visible = false;
}
